var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7196_58877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6H10.5671C10.6667 6 10.7852 6.00474 10.9227 6.01422C11.0601 6.01896 11.1929 6.03319 11.3209 6.05689C11.8756 6.14222 12.3401 6.33422 12.7147 6.63289C13.0939 6.92681 13.3784 7.29659 13.568 7.74222C13.7576 8.18785 13.8524 8.68326 13.8524 9.22844C13.8524 9.99644 13.6652 10.6578 13.2907 11.2124C12.9209 11.7624 12.3686 12.1369 11.6338 12.336C11.4584 12.3834 11.2877 12.4166 11.1218 12.4356C10.9559 12.4498 10.7639 12.4569 10.5458 12.4569H8V11.2551H10.5244C10.6145 11.2551 10.7164 11.2504 10.8302 11.2409C10.9487 11.2314 11.0601 11.2148 11.1644 11.1911C11.4916 11.1153 11.757 10.9778 11.9609 10.7787C12.1695 10.5748 12.3212 10.3378 12.416 10.0676C12.5108 9.79259 12.5582 9.51289 12.5582 9.22844C12.5582 8.944 12.5108 8.6643 12.416 8.38933C12.3212 8.11437 12.1695 7.87733 11.9609 7.67822C11.757 7.47437 11.4916 7.33689 11.1644 7.26578C11.0601 7.23733 10.9487 7.22074 10.8302 7.216C10.7164 7.20652 10.6145 7.20178 10.5244 7.20178H8V6ZM8 12.4569L9.32267 12.0444L14.0658 16.24H12.2596L8 12.4569ZM8.02844 9.73333V8.71644H14.9191V9.73333H8.02844ZM10.4391 7.01689V6H14.8907V7.01689H10.4391Z",
    fill: "#DC3545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8802 12.5525C20.9591 12.0465 21 11.528 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C11.4069 21 11.808 20.9757 12.2022 20.9285",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19C23 19.75 22.79 20.46 22.42 21.06C21.73 22.22 20.46 23 19 23C17.54 23 16.27 22.22 15.58 21.06C15.21 20.46 15 19.75 15 19C15 16.79 16.79 15 19 15C21.21 15 23 16.79 23 19Z",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 19.98L18.0195 18",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.98 18.02L18 20",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7196_58877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.96af3262cfcebf31a0117e87c70f3a97.svg";
export { ForwardRef as ReactComponent };